import React from "react";
import { Stack, Avatar, Typography } from "@mui/material";
import ActionButton from "common/components/ActionButton";
import useScopeAttributes from "common/hooks/useScopeAttributes";
import useFetcher from "common/hooks/useFetcher";
import EditorTable from "common/components/Table/editor";
import toast from "react-hot-toast";
import useState from "common/hooks/useState";
import AssetImage from "common/components/AssetImage";
export default function ModifyTenant({ tenant, refresh, onClose }) {
  const fetcher = useFetcher();
  const [confirmed, setConfirmed] = React.useState(null);
  const { tenant: e1tenant, loading, error } = useState("/api/meta");
  const { ScopeInputs, getScope, setInit } = useScopeAttributes();
  const [panelView, setPanelView] = React.useState(false);
  const [platform, setPlatform] = React.useState(tenant.type);
  const [platformConfig, setPlatformConfig] = React.useState({});
  const [tenantConfig, setTenantConfig] = React.useState({});
  const [configuration, setConfiguration] = React.useState([
    ["property", "value"],
  ]);
  const fetchPlatformConfig = async () => {
    try {
      await fetcher.get(
        "fetching platform configuration",
        `/api/platforms/${platform.toLowerCase()}/tenant/config`,
        (config) => {
          if (!config)
            return toast.error("There was an issue getting the tenant config");
          setPlatformConfig(config);
        },
        () => {}
      );
      await fetcher.get(
        "fetching tenant configuration",
        `/api/tenants/${tenant.pk}`,
        ({ config }) => {
          if (!config)
            return toast.error("There was an issue getting the tenant config");
          let configuration = [
            ["property", "value"],
            ...Object.entries(config).map(([k, v]) => {
              return { property: k, value: v };
            }),
          ];
          setTenantConfig(config);
          setConfiguration(configuration);
        },
        () => {}
      );
    } catch {}
  };
  React.useEffect(() => {
    if (!platform) return;
    setConfirmed(false);
    //get platform config file and load it
    fetchPlatformConfig();
  }, [platform]);
  React.useEffect(() => {
    if (!tenant) return;
    setInit(tenant?.tags, tenant?.acl);
  }, [tenant]);
  const addTenant = async () => {
    await fetcher.post(
      "saving tenant",
      `/api/tenants`,
      () => {
        let form = new FormData();
        let config = configuration
          .slice(1)
          .reduce((a, c) => ({ ...a, [c.property]: c.value }), {});
        form.append(
          "json",
          JSON.stringify({ ...tenant, tenantConfig: config, ...getScope() })
        );
        return form;
      },
      ({ id }, toast) => {
        if (id) {
          toast.success("Tenant saved!");
          refresh();
          return onClose();
        }
        toast.error(
          "Looks like we had an issue. If the issue persists, please contact support."
        );
      },
      (e) => {}
    );
  };
  const confirmTenant = async () => {
    let tc = configuration
      .slice(1)
      .reduce((a, c) => ({ ...a, [c.property]: c.value }), {});
    if (
      Object.keys(platformConfig).join(",") !== Object.keys(tc).join(",") ||
      tc.id !== tenantConfig.id ||
      tc.alias !== tenantConfig.alias
    ) {
      setConfirmed(false);
      return toast.error("tenant configuration is not valid");
    }
    setConfirmed(true);
  };

  return (
    <Stack p={2} gap={2}>
      <Stack alignItems={"center"} direction="row" gap={1}>
        <Avatar
          sx={{
            width: 60,
            height: 60,
            marginRight: "10px",
          }}
        >
          {platform?.pk && (
            <AssetImage
              path={`/api/assets/instance/platforms/${tenant.type}/logo.png`}
              style={{ height: "60px", width: "60px" }}
            />
          )}
        </Avatar>
        <Stack>
          <Typography variant="h4">
            {tenant?.name} ({tenant?.id})
          </Typography>
          <Typography variant="body2">modify tenant</Typography>
        </Stack>
      </Stack>
      <Stack gap={1}>
        {confirmed ? (
          <Stack gap={1}>
            <Typography sx={{ textAlign: "right" }} variant="body2">
              Your tenant has been confirmed!
            </Typography>
            <div style={{ marginLeft: "auto", display: "flex" }}>
              <ActionButton
                icon="save"
                dark
                handler={async () => {
                  await addTenant();
                }}
              >
                Modify Tenant
              </ActionButton>
            </div>
          </Stack>
        ) : (
          <div style={{ marginLeft: "auto" }}>
            <ActionButton
              icon="science"
              dark
              handler={async () => {
                await confirmTenant();
              }}
            >
              Confirm Tenant Configuration
            </ActionButton>
          </div>
        )}
      </Stack>
      {platform && platform !== "aws" ? (
        <Stack className="floating" gap={3}>
          <Typography variant="h5">Tenant Configuration</Typography>
          <Stack gap={1}>
            <Typography>
              Provide values for the tenant configuration properties. You can
              also upload a JSON file containing the values. The file must be a
              JSON object containing the properties and corresponding values.
            </Typography>
          </Stack>
          <Stack sx={{ height: "450px" }} gap={1}>
            <EditorTable
              noHeader
              noColumnMod
              noRowMod
              cellFlex
              noClearButton
              loading={false}
              data={configuration}
              close={() => {
                setConfirmed(false);
                setConfiguration([["property", "value"]]);
              }}
              save={(data) => {
                setConfirmed(false);
                setConfiguration(data);
              }}
            />
          </Stack>
        </Stack>
      ) : null}
      <Stack className="floating" gap={3}>
        <Typography variant="h5">Management</Typography>
        <ScopeInputs />
        {/* <div style={{ marginLeft: "auto" }}>
          <ActionButton
            icon="save"
            dark
            handler={async () => {
              await addTenant();
            }}
          >
            Update Tags
          </ActionButton>
        </div> */}
      </Stack>

      <div style={{ height: "100px" }} />
      {/* <Stack className="floating" gap={3}>
        <Typography variant="h5">Tenants</Typography>
        <Stack gap={1}>
          <Typography>Select tenants to assoicate with this target.</Typography>
        </Stack>
        <Stack gap={1}>
          <SidePanel
            width="700px"
            open={panelView === "tenants"}
            closeDrawer={() => setPanelView(false)}
            props={{ tenants, setTenants, platform }}
          >
            {SelectTenants}
          </SidePanel>
          <ActionButton
            disabled={!platform}
            icon="list"
            dark
            noload
            handler={async () => {
              setPanelView("tenants");
            }}
          >
            {!tenants.length
              ? "No tenants selected"
              : `${tenants.length} tenant${
                  tenants.length === 1 ? "" : "s"
                } selected`}
          </ActionButton>
        </Stack>
      </Stack>
      <Stack className="floating" gap={3}>
        <Typography variant="h5">Geographies</Typography>
        <Stack gap={1}>
          <Typography>Select geos to assoicate with this target.</Typography>
        </Stack>
        <Stack gap={1}>
          <SidePanel
            width="700px"
            open={panelView === "geos"}
            closeDrawer={() => setPanelView(false)}
            props={{ geos, setGeos, platform }}
          >
            {SelectGeos}
          </SidePanel>
          <ActionButton
            icon="location_on"
            disabled={!platform}
            dark
            noload
            handler={async () => {
              setPanelView("geos");
            }}
          >
            {!geos.length
              ? "No geographies selected"
              : `${geos.length} geograph${
                  geos.length === 1 ? "y" : "ies"
                } selected`}
          </ActionButton>
        </Stack>
      </Stack>
      <Stack className="floating" gap={3}>
        <Typography variant="h5">Access Control</Typography>
        <Stack gap={1}>
          <ScopeInputs />
        </Stack>
      </Stack>
      <div style={{ marginLeft: "auto", display: "flex" }}>
        <ActionButton
          icon="save"
          dark
          handler={async () => {
            await createTarget();
          }}
        >
          Save Target
        </ActionButton>
      </div> */}
    </Stack>
  );
}
